<template>
    <div class="textbanner" v-on:click="toggle()" v-if="visible">
        <div class="keyline"></div>
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "TextBanner",
        data: function ()
        {
            return {
                visible: true,
            };
        },
        methods: {
            toggle: function ()
            {
                this.$el.classList.toggle('is-hidden');
            }
        },
        created()
        {
            this.$eventBus.$on('InfoBox.show', (value) =>
            {
                this.visible = (value === false);
            });
        }

        // TODO TBD visible, toggle, .. v-if="visible"
    };
</script>

<style scoped lang="scss">

    @import "../assets/scss/functions";
    @import "../assets/scss/variables";
    @import "../assets/scss/mixins";

    .textbanner {

        pointer-events: auto;

        position: absolute;
        z-index: map_get($z-layers, textbanner);

        bottom: 0;
        left: 50%;
        transform: translateX(-50%);

        width: 100%;
        max-width: 640px;
        padding: gridColumnsToRem(3);

        background: rgba($warm-gray, .8);
        transition: all $transition-default;

        :last-child {
            margin-bottom: 0;
        }

        &::before {
            content: '\00D7';
            padding: .5rem;
            position: absolute;
            top: 0;
            right: 0;
            transform: rotate(0);
            transition: transform $transition-default;
            cursor: pointer;
        }

        &.is-hidden {
            left: gridColumnsToRem(5);
            opacity: .35;
            transform: translateX(-100%);
        }

        &.is-hidden::before {
            transform: rotate(45deg);
        }
    }
</style>